import { actionFactory } from 'redux/factories';
import { types } from './types';

export const getBanks = actionFactory(types.GET_BANKS);
export const addBank = actionFactory(types.ADD_BANK);
export const updateBank = actionFactory(types.UPDATE_BANK);
export const deleteBank = actionFactory(types.DELETE_BANK);
